import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useUser as useClerkUser } from '@clerk/clerk-react';
import logo from '@/assets/logo.png';
import Button from '@/components/Button';
import { ArrowRight } from 'lucide-react';

// Public-facing "first contact" landing — what the QR on the front of the
// welcome kit (and the inside back cover) resolves to. A warm, single-screen
// hello before handing off to /signin, which carries all the routing logic
// (catchall pending-invite detection, etc.).

export const Route = createFileRoute('/welcome')({
  component: WelcomePage,
});

function WelcomePage() {
  const navigate = useNavigate();
  const { user, isLoaded } = useClerkUser();

  // Already signed in on this device: skip the welcome moment and let the
  // existing post-auth gates (subscription, onboarding, pending invite) take
  // them wherever they should go.
  useEffect(() => {
    if (isLoaded && user) {
      navigate({ to: '/', search: { invitationcode: undefined, __clerk_ticket: undefined } });
    }
  }, [isLoaded, user, navigate]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-md w-full flex flex-col items-center text-center">
        <img src={logo} alt="GranGuard" className="w-48 sm:w-56 mb-10" />

        <h1
          className="font-semibold text-gray-900 leading-tight tracking-tight mb-4"
          style={{ fontSize: 'clamp(2rem, 6vw, 2.75rem)' }}
        >
          Welcome to GranGuard.
        </h1>

        <p className="text-lg text-gray-500 leading-relaxed mb-10">
          Sign in or set up your account. We'll guide you the rest of the way.
        </p>

        <Button
          variant="primary"
          size="xlarge"
          fullWidth
          onClick={() =>
            navigate({
              to: '/signup',
              search: {
                invitationcode: undefined,
                __clerk_ticket: undefined,
                showSubModal: undefined,
                redirectTo: undefined,
              },
            })
          }
        >
          Get started <ArrowRight className="w-5 h-5 inline" />
        </Button>
      </div>
    </div>
  );
}
